import(/* webpackMode: "eager" */ "/vercel/path0/src/app/settings/page.tsx");
